'use strict';

angular.module('portal.inspections')
    .controller('PortalInspectionsSignatureModal', ['$scope', '$rootScope', '$uibModalInstance', 'inspections', '$uibModal', 'Account', function ($scope, $rootScope, $uibModalInstance, inspections, $uibModal, Account) {

        $scope.inspections = inspections;
        $scope.credentials = {};
        $scope.continuing = false;
        $scope.disregarding = false;
        $scope.invalid = false;

        $scope.save = function () {
            $scope.continuing = true;
            $scope.invalid = false;

            Account.validate($scope.credentials.password, $rootScope.userAccount.user_name).then(function (data) {
                $scope.continuing = false;

                if (data != null) {
                    if (data.valid) {
                        $scope.invalid = false;
                        $uibModalInstance.close(true);
                    }
                    else {
                        $scope.invalid = true;
                    }
                }
                else {
                    $scope.invalid = true;
                }
            });
        }

        $scope.disregard = function () {
            $scope.disregarding = true;

            $uibModal.open({
                animation: true,
                templateUrl: 'templates/confirm/confirm.html',
                controller: 'ConfirmModalController',
                resolve: {
                    message: function () {
                        return "You are about to diregard and lose the data for the checklists listed below that require a signature.  All other inspections in the visit will be checked in.";
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    $uibModalInstance.close(false);
                }
                else {
                    $scope.disregarding = false;
                }
            }, function () {
                $scope.disregarding = false;
            });
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
            $scope.$destroy();
        }

        $scope.$on('$destroy', function () {
        });
    }])
;